import { atomFamily } from 'recoil';

interface IToastFamily {
  key: string;
  open: boolean;
  onClose: () => void;
  message: string;
}

// family == factory 같은 기능
// 각각의 atom 을 id 로 관리
export const toastFamily = atomFamily<IToastFamily, string>({
  key: 'toastFamily',
  default: (id) => ({
    key: id,
    open: false,
    onClose: () => {},
    message: '',
  }),
});
